var map = {
	"./Coins": [
		9870,
		870
	],
	"./Coins/": [
		9870,
		870
	],
	"./Coins/index": [
		9870,
		870
	],
	"./Coins/index.tsx": [
		9870,
		870
	],
	"./Home": [
		5826,
		826
	],
	"./Home/": [
		5826,
		826
	],
	"./Home/index": [
		5826,
		826
	],
	"./Home/index.tsx": [
		5826,
		826
	],
	"./PrivacyPolicy": [
		2643,
		643
	],
	"./PrivacyPolicy/": [
		2643,
		643
	],
	"./PrivacyPolicy/index": [
		2643,
		643
	],
	"./PrivacyPolicy/index.tsx": [
		2643,
		643
	],
	"./TermsAndConditions": [
		5096,
		96
	],
	"./TermsAndConditions/": [
		5096,
		96
	],
	"./TermsAndConditions/index": [
		5096,
		96
	],
	"./TermsAndConditions/index.tsx": [
		5096,
		96
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;